var map = {
	"./BetMGM.svg": 1441,
	"./Entain.svg": 8316,
	"./EstrelaBet.png": 6,
	"./Everi.svg": 3729,
	"./JG-logo.png": 3086,
	"./JG-logo.svg": 8840,
	"./banners/banner_3strikes.jpg": 8915,
	"./banners/banner_Entain.jpg": 1355,
	"./banners/banner_Entain_aviador.jpg": 2331,
	"./banners/banner_Everi.jpg": 6064,
	"./banners/banner_FF.jpg": 1158,
	"./banners/banner_FF_JG02.png": 3217,
	"./banners/banner_FF_bingo.jpg": 9282,
	"./banners/banner_FF_risingfortunes.jpg": 689,
	"./banners/banner_FF_risingshowdown.jpg": 3403,
	"./banners/banner_Fanduel.jpg": 4268,
	"./banners/banner_JG.png": 87,
	"./banners/banner_LMAD.jpg": 9730,
	"./banners/banner_Survivor.jpg": 7059,
	"./banners/banner_TPIR.jpg": 719,
	"./banners/banner_beebet.png": 812,
	"./banners/banner_betfred.png": 3911,
	"./banners/banner_bigbrother.jpg": 9922,
	"./banners/banner_esportesdasorte.png": 4557,
	"./banners/banner_estrelabet.png": 4347,
	"./banners/banner_everi-betmgm.jpg": 291,
	"./banners/banner_everi_bcc.png": 7692,
	"./banners/banner_everi_cpb.png": 1061,
	"./banners/banner_everi_dond.png": 5287,
	"./banners/banner_everi_ds.png": 9880,
	"./banners/banner_everi_ek.png": 2485,
	"./banners/banner_everi_ge.png": 9397,
	"./banners/banner_everi_pp.png": 5745,
	"./banners/banner_everi_scc.png": 3240,
	"./banners/banner_everi_ssr.png": 654,
	"./banners/banner_everi_tvoice.png": 8143,
	"./banners/banner_everi_vo.png": 1294,
	"./banners/banner_everi_vod.png": 3787,
	"./banners/banner_everi_vof.png": 7998,
	"./banners/banner_everi_wwtbammines.png": 4163,
	"./banners/banner_everi_wwtbamspin.png": 7318,
	"./banners/banner_everi_ycs.png": 7920,
	"./banners/banner_fanduel_b.png": 3000,
	"./banners/banner_fanduel_ou.png": 4646,
	"./banners/banner_fanduel_pns.png": 5646,
	"./banners/banner_fearfactor.jpg": 9670,
	"./banners/banner_gamingrealms.png": 1370,
	"./banners/banner_holeinone.jpg": 3904,
	"./banners/banner_letemroll.jpg": 4792,
	"./banners/banner_moneydrop.jpg": 778,
	"./banners/banner_novibet.png": 5861,
	"./banners/banner_outros.png": 3954,
	"./banners/banner_pathfinder.jpg": 6467,
	"./banners/banner_punchabunch.jpg": 3670,
	"./banners/banner_ratrace.jpg": 2396,
	"./banners/banner_spellingbee.jpg": 437,
	"./banners/banner_survivorGAG.jpg": 678,
	"./banners/banner_survivorHT.jpg": 4906,
	"./banners/banner_survivorIH.jpg": 4881,
	"./banners/banner_survivorLS.jpg": 9926,
	"./banners/banner_survivorS50.jpg": 5585,
	"./banners/banner_survivorSAS.jpg": 166,
	"./banners/banner_survivorTT.jpg": 694,
	"./banners/banner_survivorWIRIP.jpg": 2113,
	"./banners/banner_survivorWTP.jpg": 7963,
	"./banners/banner_survivorflameout.jpg": 4157,
	"./banners/banner_traitors.jpg": 5735,
	"./banners/big-wheel-banner.jpg": 2137,
	"./banners/cliffhangers-banner.jpg": 3165,
	"./banners/mainBanner.png": 2280,
	"./banners/plinko-banner.jpg": 4174,
	"./black_logo.svg": 9933,
	"./brandIcons/logo_BB.png": 8663,
	"./brandIcons/logo_FF.png": 4669,
	"./brandIcons/logo_FFA.png": 2489,
	"./brandIcons/logo_LMAD.png": 4802,
	"./brandIcons/logo_MD.png": 1996,
	"./brandIcons/logo_S.png": 8558,
	"./brandIcons/logo_TPIR.png": 2465,
	"./brandIcons/logo_betmgm.png": 2349,
	"./brandIcons/logo_everi.png": 755,
	"./brandIcons/logo_fanduel.png": 4703,
	"./brandIcons/logo_traitors.png": 1377,
	"./famicons_filter.svg": 2178,
	"./thumbnails/thumb-JGGames-Abracaspin.png": 6393,
	"./thumbnails/thumb-JGGames-AlienPick.png": 6468,
	"./thumbnails/thumb-JGGames-Bullionaire.png": 5184,
	"./thumbnails/thumb-JGGames-BunnyBonanza.png": 669,
	"./thumbnails/thumb-JGGames-ChilliChilliBoomBoom.png": 1174,
	"./thumbnails/thumb-JGGames-CircleOfStone.png": 281,
	"./thumbnails/thumb-JGGames-CrashMan.png": 1967,
	"./thumbnails/thumb-JGGames-DONDJogoGlobal.png": 6162,
	"./thumbnails/thumb-JGGames-DragonRiches.png": 2258,
	"./thumbnails/thumb-JGGames-FestivalOfTheDead.png": 2462,
	"./thumbnails/thumb-JGGames-GoldenBanana.png": 6640,
	"./thumbnails/thumb-JGGames-GoldenTiger.png": 2458,
	"./thumbnails/thumb-JGGames-JogaNas11.png": 8252,
	"./thumbnails/thumb-JGGames-JokerRoyale.png": 2716,
	"./thumbnails/thumb-JGGames-JokersTreasure.png": 1296,
	"./thumbnails/thumb-JGGames-KingdomOfGold.png": 955,
	"./thumbnails/thumb-JGGames-KungFoodPanda.png": 1252,
	"./thumbnails/thumb-JGGames-LuckyDynasty.png": 6385,
	"./thumbnails/thumb-JGGames-LuckyTigerMines.png": 9289,
	"./thumbnails/thumb-JGGames-LuckyTigerSpin.png": 2252,
	"./thumbnails/thumb-JGGames-MariachiMadness.png": 7335,
	"./thumbnails/thumb-JGGames-MotoStar.png": 4813,
	"./thumbnails/thumb-JGGames-MummysFortune.png": 1697,
	"./thumbnails/thumb-JGGames-OinkMajesty.png": 8814,
	"./thumbnails/thumb-JGGames-Quackpot.png": 7342,
	"./thumbnails/thumb-JGGames-RainbowFrenzy.png": 9462,
	"./thumbnails/thumb-JGGames-SirensTreasure.png": 5225,
	"./thumbnails/thumb-JGGames-SpinStar.png": 5882,
	"./thumbnails/thumb-JGGames-SplashnCash.png": 510,
	"./thumbnails/thumb-JGGames-StarCrash.png": 9564,
	"./thumbnails/thumb-JGGames-StarMines.png": 4981,
	"./thumbnails/thumb-JGGames-Surfista.png": 4179,
	"./thumbnails/thumb-JGGames-TempleOfSecrets.png": 3083,
	"./thumbnails/thumb-JGGames-TicketToMars-v2.png": 9285,
	"./thumbnails/thumb-JGGames-TicketToMars.png": 5361,
	"./thumbnails/thumb-JGGames-TigerMania.png": 6200,
	"./thumbnails/thumb-JGGames-TigerReel-v2.png": 7065,
	"./thumbnails/thumb-JGGames-TigerReel.png": 9130,
	"./thumbnails/thumb-JGGames-VolcanoRiches.png": 8407,
	"./thumbnails/thumb-JGGames-WWTBAMMines.png": 5656,
	"./thumbnails/thumb-JGGames-WWTBAMSpins.png": 7833,
	"./thumbnails/thumb-beebet-BeeBat.png": 1786,
	"./thumbnails/thumb-beebet-BeeJet.png": 4989,
	"./thumbnails/thumb-beebet-Zoomex.png": 7479,
	"./thumbnails/thumb-betfred-ArmedBandits.png": 6762,
	"./thumbnails/thumb-betfred-Blackjack.png": 5807,
	"./thumbnails/thumb-betfred-ChandanTheMagnificent.png": 6871,
	"./thumbnails/thumb-betfred-CleopatrasAss.png": 6526,
	"./thumbnails/thumb-betfred-CleopatrasNeedle.png": 5739,
	"./thumbnails/thumb-betfred-DiamondGeezer.png": 9181,
	"./thumbnails/thumb-betfred-DiamondsAndDollars.png": 332,
	"./thumbnails/thumb-betfred-FruityBooty.png": 7285,
	"./thumbnails/thumb-betfred-JewelOfTheIsle.png": 1373,
	"./thumbnails/thumb-betfred-LastHeist.png": 3579,
	"./thumbnails/thumb-betfred-Roulette.png": 8046,
	"./thumbnails/thumb-betmgm-survivor-run.png": 3168,
	"./thumbnails/thumb-coming-soon.png": 4973,
	"./thumbnails/thumb-entain-capirinha.png": 4324,
	"./thumbnails/thumb-esportesdasorte-DoubleDoBicho.png": 2934,
	"./thumbnails/thumb-esportesdasorte-DoublePlus.png": 2913,
	"./thumbnails/thumb-esportesdasorte-Jetman.png": 4123,
	"./thumbnails/thumb-esportesdasorte-Kickoff.png": 3211,
	"./thumbnails/thumb-esportesdasorte-StarMines.png": 1628,
	"./thumbnails/thumb-estrelabet-3PotsBrasil.png": 1767,
	"./thumbnails/thumb-estrelabet-Aviaozinho.png": 7829,
	"./thumbnails/thumb-estrelabet-DoceBonanza.png": 898,
	"./thumbnails/thumb-estrelabet-DoubleStars.png": 5063,
	"./thumbnails/thumb-estrelabet-FlyOvni.png": 9751,
	"./thumbnails/thumb-estrelabet-MacacoDaFortuna.png": 924,
	"./thumbnails/thumb-estrelabet-Motograu-v2.png": 4374,
	"./thumbnails/thumb-estrelabet-Motograu.png": 1230,
	"./thumbnails/thumb-estrelabet-PandaDaFortuna.png": 6219,
	"./thumbnails/thumb-estrelabet-StarMines.png": 5648,
	"./thumbnails/thumb-estrelabet-Stellar.png": 4068,
	"./thumbnails/thumb-estrelabet-VelhoDoRaioSortudo.png": 8507,
	"./thumbnails/thumb-everi-BottleCrashCourse.png": 5916,
	"./thumbnails/thumb-everi-CosmicPinballBlast.png": 9050,
	"./thumbnails/thumb-everi-DoubleSalmon.png": 5849,
	"./thumbnails/thumb-everi-EaglesReign.png": 0,
	"./thumbnails/thumb-everi-EvelKnievel.png": 7311,
	"./thumbnails/thumb-everi-Puffer-Popper.png": 2691,
	"./thumbnails/thumb-everi-SkateCityCrash.png": 2420,
	"./thumbnails/thumb-everi-StarStruckRiches.png": 6559,
	"./thumbnails/thumb-everi-TheVoice.png": 459,
	"./thumbnails/thumb-everi-VaultOfDestiny.png": 768,
	"./thumbnails/thumb-everi-VaultOfFortune.png": 6528,
	"./thumbnails/thumb-everi-WWTBAM-Mines.png": 4912,
	"./thumbnails/thumb-everi-WWTBAM-Spin.png": 1089,
	"./thumbnails/thumb-everi-YetiCashSmash.png": 90,
	"./thumbnails/thumb-everi-dond.png": 2203,
	"./thumbnails/thumb-everi-vegging.png": 7301,
	"./thumbnails/thumb-fanduel-Bingo.png": 2457,
	"./thumbnails/thumb-fanduel-OverUnder.png": 8560,
	"./thumbnails/thumb-fanduel-PickNSpin.png": 3390,
	"./thumbnails/thumb-fanduel-commingsoon.png": 286,
	"./thumbnails/thumb-ff-bingo.png": 1765,
	"./thumbnails/thumb-ff-rising-fortunes.png": 5923,
	"./thumbnails/thumb-ff-showdown.png": 7932,
	"./thumbnails/thumb-lmad-1.png": 9667,
	"./thumbnails/thumb-lmad-10.png": 4639,
	"./thumbnails/thumb-lmad-2.png": 5697,
	"./thumbnails/thumb-lmad-3.png": 3074,
	"./thumbnails/thumb-lmad-4.png": 1647,
	"./thumbnails/thumb-lmad-5.png": 3088,
	"./thumbnails/thumb-lmad-6.png": 3161,
	"./thumbnails/thumb-lmad-7.png": 6870,
	"./thumbnails/thumb-lmad-8.png": 5718,
	"./thumbnails/thumb-lmad-9.png": 2293,
	"./thumbnails/thumb-novibet-CrashOfTheGods.png": 9914,
	"./thumbnails/thumb-novibet-DONDGreece.png": 457,
	"./thumbnails/thumb-novibet-SurvivorGreece.png": 6487,
	"./thumbnails/thumb-novibet-SurvivorSpin.png": 9231,
	"./thumbnails/thumb-others-DoubleDoBicho.png": 7372,
	"./thumbnails/thumb-others-Eish.png": 2274,
	"./thumbnails/thumb-others-FanRasp.png": 3599,
	"./thumbnails/thumb-others-FanSlot.png": 7014,
	"./thumbnails/thumb-others-Grau7k.png": 8857,
	"./thumbnails/thumb-others-JokersDouble.png": 6443,
	"./thumbnails/thumb-others-JokersGold.png": 6291,
	"./thumbnails/thumb-others-Kickoff.png": 5724,
	"./thumbnails/thumb-others-SlingoChinaShores.png": 2956,
	"./thumbnails/thumb-others-SlingoCleopatra.png": 8919,
	"./thumbnails/thumb-others-SlingoGE.png": 1483,
	"./thumbnails/thumb-others-SlingoSW.png": 1555,
	"./thumbnails/thumb-others-SuperBomb.png": 4661,
	"./thumbnails/thumb-survivor-50.png": 5181,
	"./thumbnails/thumb-survivor-flame-out.png": 9734,
	"./thumbnails/thumb-survivor-get-a-grip.png": 4984,
	"./thumbnails/thumb-survivor-hidden-treasures.png": 9743,
	"./thumbnails/thumb-survivor-immunity-hunt.png": 9819,
	"./thumbnails/thumb-survivor-last-step.png": 3862,
	"./thumbnails/thumb-survivor-spin.png": 9965,
	"./thumbnails/thumb-survivor-sumo-at-sea.png": 1353,
	"./thumbnails/thumb-survivor-tribal-council.png": 3880,
	"./thumbnails/thumb-survivor-tribal-tumble.png": 4967,
	"./thumbnails/thumb-survivor-walk plank.png": 2352,
	"./thumbnails/thumb-survivor-walk-plank.png": 402,
	"./thumbnails/thumb-survivor-wirip.png": 2711,
	"./thumbnails/thumb-tpir-3strike.png": 3887,
	"./thumbnails/thumb-tpir-big-wheel.png": 6356,
	"./thumbnails/thumb-tpir-cliffhangers.png": 5752,
	"./thumbnails/thumb-tpir-hole-in-one.png": 5607,
	"./thumbnails/thumb-tpir-let-em-roll.png": 1601,
	"./thumbnails/thumb-tpir-pathfinder.png": 4918,
	"./thumbnails/thumb-tpir-plinko.png": 1604,
	"./thumbnails/thumb-tpir-punch-a-bunch.png": 9713,
	"./thumbnails/thumb-tpir-rat-race.png": 8981,
	"./thumbnails/thumb-tpir-spelling-bee.png": 8455,
	"./thumbnails/thumbnail-Entain-Aviador1.jpg": 5233,
	"./thumbnails/thumbnail-Entain-commingsoon.jpg": 9487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;